import { render, staticRenderFns } from "./notWx.vue?vue&type=template&id=6436fcea&scoped=true&"
import script from "./notWx.vue?vue&type=script&lang=js&"
export * from "./notWx.vue?vue&type=script&lang=js&"
import style0 from "./notWx.vue?vue&type=style&index=0&id=6436fcea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6436fcea",
  null
  
)

export default component.exports